/**
 * Generated by orval v6.15.0 🍺
 * Do not edit manually.
 * SMP Backend API (Public)
 * The SMP backend API description
 * OpenAPI spec version: 1.0
 */
import { customAxios } from '../lib/axios';

import type {
  LanguageDto,
  ServiceBookingRequest,
  RegisterCustomerRequest,
  CompleteRegistrationRequest,
  ServiceBookingCancellationDto,
  ServiceBookingVerificationDto,
  ServiceBookingVerificationRequestDto,
} from './web-dtos';

export const getSMPBackendAPIPublic = () => {
  const requestControllerGetAllLanguagesV1 = () => {
    return customAxios<LanguageDto[]>({ url: `/api/v1/request/languages`, method: 'get' });
  };

  const requestControllerSendRequestV1 = (serviceBookingRequest: ServiceBookingRequest) => {
    const formData = new FormData();
    if (serviceBookingRequest.file !== undefined) {
      formData.append('file', serviceBookingRequest.file);
    }
    formData.append('customerNumber', serviceBookingRequest.customerNumber.toString());
    if (serviceBookingRequest.debtorNumber !== undefined) {
      formData.append('debtorNumber', serviceBookingRequest.debtorNumber.toString());
    }
    if (serviceBookingRequest.resourceNumber !== undefined) {
      formData.append('resourceNumber', serviceBookingRequest.resourceNumber.toString());
    }
    formData.append('date', serviceBookingRequest.date);
    formData.append('languageId', serviceBookingRequest.languageId);
    if (serviceBookingRequest.alternativeLanguageId !== undefined) {
      formData.append('alternativeLanguageId', serviceBookingRequest.alternativeLanguageId);
    }
    formData.append('contactPerson', JSON.stringify(serviceBookingRequest.contactPerson));
    formData.append('type', serviceBookingRequest.type);
    if (serviceBookingRequest.onsite !== undefined) {
      formData.append('onsite', JSON.stringify(serviceBookingRequest.onsite));
    }
    if (serviceBookingRequest.phone !== undefined) {
      formData.append('phone', JSON.stringify(serviceBookingRequest.phone));
    }
    if (serviceBookingRequest.remote !== undefined) {
      formData.append('remote', JSON.stringify(serviceBookingRequest.remote));
    }
    if (serviceBookingRequest.document !== undefined) {
      formData.append('document', JSON.stringify(serviceBookingRequest.document));
    }
    if (serviceBookingRequest.client !== undefined) {
      formData.append('client', JSON.stringify(serviceBookingRequest.client));
    }
    if (serviceBookingRequest.gender !== undefined) {
      formData.append('gender', serviceBookingRequest.gender);
    }
    if (serviceBookingRequest.acceptAlternativeResource !== undefined) {
      formData.append(
        'acceptAlternativeResource',
        serviceBookingRequest.acceptAlternativeResource.toString()
      );
    }
    if (serviceBookingRequest.specialRate !== undefined) {
      formData.append('specialRate', serviceBookingRequest.specialRate.toString());
    }
    if (serviceBookingRequest.notes !== undefined) {
      formData.append('notes', serviceBookingRequest.notes);
    }

    return customAxios<void>({
      url: `/api/v1/request/booking`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  const requestControllerRegisterCustomerV1 = (
    registerCustomerRequest: RegisterCustomerRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/request/register-customer`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: registerCustomerRequest,
    });
  };

  const requestControllerCompleteRegistrationV1 = (
    completeRegistrationRequest: CompleteRegistrationRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/request/complete-registration`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: completeRegistrationRequest,
    });
  };

  const requestControllerCancelRequestV1 = (id: string) => {
    return customAxios<ServiceBookingCancellationDto>({
      url: `/api/v1/request/booking/${id}/cancel`,
      method: 'get',
    });
  };

  const requestControllerConfirmCancelRequestV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/request/booking/${id}/cancel`, method: 'post' });
  };

  const requestControllerGetBookingVerificationV1 = (id: string) => {
    return customAxios<ServiceBookingVerificationDto>({
      url: `/api/v1/request/booking/${id}/verify`,
      method: 'get',
    });
  };

  const requestControllerVerifyBookingV1 = (
    id: string,
    serviceBookingVerificationRequestDto: ServiceBookingVerificationRequestDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/request/booking/${id}/verify`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: serviceBookingVerificationRequestDto,
    });
  };

  return {
    requestControllerGetAllLanguagesV1,
    requestControllerSendRequestV1,
    requestControllerRegisterCustomerV1,
    requestControllerCompleteRegistrationV1,
    requestControllerCancelRequestV1,
    requestControllerConfirmCancelRequestV1,
    requestControllerGetBookingVerificationV1,
    requestControllerVerifyBookingV1,
  };
};
export type RequestControllerGetAllLanguagesV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIPublic>['requestControllerGetAllLanguagesV1']>
  >
>;
export type RequestControllerSendRequestV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIPublic>['requestControllerSendRequestV1']>>
>;
export type RequestControllerRegisterCustomerV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIPublic>['requestControllerRegisterCustomerV1']>
  >
>;
export type RequestControllerCompleteRegistrationV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIPublic>['requestControllerCompleteRegistrationV1']>
  >
>;
export type RequestControllerCancelRequestV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIPublic>['requestControllerCancelRequestV1']>>
>;
export type RequestControllerConfirmCancelRequestV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIPublic>['requestControllerConfirmCancelRequestV1']>
  >
>;
export type RequestControllerGetBookingVerificationV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIPublic>['requestControllerGetBookingVerificationV1']
    >
  >
>;
export type RequestControllerVerifyBookingV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIPublic>['requestControllerVerifyBookingV1']>>
>;
